import {
  initialState,
  Actions,
  State,
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_ERROR,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_ERROR,
  SIGN_OUT,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_ERROR,
  SEND_PASSWORD_RECOVERY_EMAIL,
  SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS,
  SEND_PASSWORD_RECOVERY_EMAIL_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  RESET_CHANGE_PASSWORD
} from '../types/auth'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        signin: {
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      }
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        signin: {
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      }
    case SIGN_IN_ERROR:
      return {
        ...state,
        signin: {
          states: {
            loading: false,
            success: false,
            error: action.payload,
          },
        },
      }
    case SIGN_UP:
      return {
        ...state,
        signup: {
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      }
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        signup: {
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      }
    case SIGN_UP_ERROR:
      return {
        ...state,
        signup: {
          states: {
            loading: false,
            success: false,
            error: action.payload,
          },
        },
      }
    case SIGN_OUT:
      return {
        ...state,
        signout: {
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      }
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        signout: {
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      }
    case SIGN_OUT_ERROR:
      return {
        ...state,
        signout: {
          states: {
            loading: false,
            success: false,
            error: action.payload,
          },
        },
      }
    case SEND_PASSWORD_RECOVERY_EMAIL:
      return {
        ...state,
        sendPasswordRecoveryEmail: {
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      }
    case SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS:
      return {
        ...state,
        sendPasswordRecoveryEmail: {
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      }
    case SEND_PASSWORD_RECOVERY_EMAIL_ERROR:
      return {
        ...state,
        sendPasswordRecoveryEmail: {
          states: {
            loading: false,
            success: false,
            error: action.payload,
          },
        },
      }

    case RESET_PASSWORD:
      return {
        ...state,
        resetPassword: {
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      }
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPassword: {
          states: {
            loading: false,
            success: false,
            error: action.payload,
          },
        },
      }
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePassword: {
          states: {
            loading: true,
            success: false,
            error: false,
          },
        },
      }
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: {
          states: {
            loading: false,
            success: true,
            error: false,
          },
        },
      }
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        changePassword: {
          states: {
            loading: false,
            success: false,
            error: action.payload,
          },
        },
      }
    case RESET_CHANGE_PASSWORD:
      return {
        ...state,
        changePassword: initialState.changePassword,
      }
    default:
      return state
  }
}

export default reducers
